import { FC } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import Footer from '../Footer';
import FullFooter from '../FullFooter';
import Header from '../Header';
import LineBlock from '../LineBlock';
import { Dialogs } from '../Dialogs';
import { isVac } from 'utilities/is-vac';
import { Language } from 'providers/translates/enums';
import { useTranslates } from 'providers/translates';

interface LayoutProps {}

const Layout: FC<LayoutProps> = () => {
  const location = useLocation();
  const { selectedLang } = useTranslates();
  const isFrench = selectedLang === Language.FRENCH;

  return (
    <div className={`App${isVac() ? ' isVac' : ''}${isFrench ? ' FR' : ''} `} style={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Header />
      <LineBlock />
      <main style={{ flexGrow: 1 }}>
        <Outlet />
        <Dialogs />
      </main>
      <LineBlock />
      {location.pathname === '/' ? <FullFooter /> : <Footer />}      
    </div>
  );
};

export default Layout;
